import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Times from 'icons/src/Times';
import Button from '../button/index';
import useMediaPopup from './use-media-popup';

const GlobalStyle = createGlobalStyle`
  body {
    height: 100vh;
    height: 100dvh;
    overflow-y: hidden !important;
  }
`;

const OverlayHeader = styled(Button).attrs({ wrapper: true })`
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: flex-end;
  color: white;
  width: 100%;
  &:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }

  svg {
    width: 1rem;
    height: 1.6rem;
    color: white;
  }
`;

const Overlay = styled.div`
  z-index: 9;
  position: fixed;
  height: 100vh;
  height: 100dvh;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
`;

const OverlayComponent = () => {
  const {
    setImagesOpen,
    setVideosOpen,
  } = useMediaPopup();
  return (
    <Overlay>
      <GlobalStyle />
      <OverlayHeader
        aria-label="Sluit media popup"
        onClick={() => {
          setImagesOpen(false);
          setVideosOpen(false);
        }}
        eventActionResult="close"
      >
        <Times />
      </OverlayHeader>
    </Overlay>
  );
};

export default OverlayComponent;
